import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const PrivacyPolicyEN = () => {
    const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800 leading-relaxed">
                <Link to="/it/privacypolicy" className="text-sm font-medium text-indigo-600 hover:text-indigo-800 transition-colors">
                  {t('ToItalian')}
                </Link>
      
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="italic mb-6">Last updated: November 03, 2025</p>

      <p className="mb-6">
        This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
      </p>

      <p className="mb-6">
        We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the Privacy Policy Generator.
      </p>

      <h2 className="text-2xl font-semibold mb-3">Interpretation and Definitions</h2>

      <h3 className="text-xl font-semibold mb-2">Interpretation</h3>
      <p className="mb-6">
        The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
      </p>

      <h3 className="text-xl font-semibold mb-2">Definitions</h3>
      <p className="mb-6">For the purposes of this Privacy Policy:</p>

      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
        <li><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</li>
        <li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to SnakeBee.</li>
        <li><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
        <li><strong>Country</strong> refers to: Italy</li>
        <li><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
        <li><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
        <li><strong>Service</strong> refers to the Website.</li>
        <li><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</li>
        <li><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</li>
        <li><strong>Website</strong> refers to SnakeBee, accessible from <a href="https://snakebee.it" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">https://snakebee.it</a></li>
        <li><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
      </ul>

      {/* --- Sezione: Collecting and Using Your Personal Data --- */}
      <h2 className="text-2xl font-semibold mb-3">Collecting and Using Your Personal Data</h2>

      <h3 className="text-xl font-semibold mb-2">Types of Data Collected</h3>

<h4 className="text-lg font-semibold mb-1">Personal Data</h4>
<p className="mb-2">
While using Our Service, we may ask you to provide
certain personal information that can be used to
contact or identify you. Personal information may
include, but is not limited to:

</p>
<ul className="list-disc pl-6 space-y-1 mb-4">
<li>Email address</li>
<li>First and last name</li>
<li>Profile picture (avatar), if provided via Google</li>
<li>Phone number</li>
<li>Address, state, province, ZIP code, city</li>
<li>
Tax information (only if provided for billing purposes), such as
Tax ID, VAT number, SDI code, and certified email address
</li>
<li>
Telegram user ID (only if you choose to connect your account to
our Telegram bot)
</li>
<li>
Links to social media profiles (e.g., Facebook, Instagram), if you choose to
include them in your profile
</li>
<li>
Information related to the referral program (e.g., the code
of the person who invited you)
</li>
<li>Usage Data</li>
</ul>

      <h4 className="text-lg font-semibold mb-1">Usage Data</h4>
      <p className="mb-2">Usage Data is collected automatically when using the Service.</p>
      <p className="mb-2">
        Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
      </p>
      <p className="mb-2">
        When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.
      </p>
      <p className="mb-6">
        We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.
      </p>

      <h3 className="text-xl font-semibold mb-2">Tracking Technologies and Cookies</h3>
      <p className="mb-2">
        We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The technologies We use may include:
      </p>
        <a href="https://www.flaticon.com/free-icons/visa" title="visa icons">Visa icons created by Freepik - Flaticon</a>

      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>
          <strong>Cookies or Browser Cookies:</strong> A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use Cookies.
        </li>
        <li>
          <strong>Web Beacons:</strong> Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity).
        </li>
        <li>
          Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on Your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close Your web browser. You can learn more about cookies on TermsFeed website article.
        </li>
      </ul>

      <p className="mb-4">
        We use both Session and Persistent Cookies for the purposes set out below:
      </p>

      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>
          <strong>Necessary / Essential Cookies</strong><br />
          Type: Session Cookies<br />
          Administered by: Us<br />
          Purpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.
        </li>
        <li>
          <strong>Cookies Policy / Notice Acceptance Cookies</strong><br />
          Type: Persistent Cookies<br />
          Administered by: Us<br />
          Purpose: These Cookies identify if users have accepted the use of cookies on the Website.
        </li>
        <li>
          <strong>Functionality Cookies</strong><br />
          Type: Persistent Cookies<br />
          Administered by: Us<br />
          Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.
        </li>
      </ul>

      <p className="mb-6">
        For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy.
      </p>

      <h2 className="text-2xl font-semibold mb-3">Use of Your Personal Data</h2>

      <p className="mb-2">
        The Company may use Personal Data for the following purposes:
      </p>

      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>To provide and maintain our Service, including to monitor the usage of our Service.</li>
        <li>
          To manage Your Account: to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.
        </li>
        <li>
          For the performance of a contract: the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.
        </li>
        <li>
          To contact You: To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.
        </li>
        <li>
          To provide You with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.
        </li>
        <li>To manage Your requests: To attend and manage Your requests to Us.</li>
        <li>
          For business transfers: We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.
        </li>
        <li>
          For other purposes: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.
        </li>
      </ul>
<h3 className="text-xl font-semibold mb-2">
Purposes and Legal Basis of Processing
</h3>
<p className="mb-2">
We process your Personal Data for the following purposes and on the following
legal bases:

</p>
<ul className="list-disc pl-6 space-y-2 mb-6">
<li>
<strong>Account and Service Management:</strong> to provide the
Service, manage your account, and authenticate access (including
Google OAuth). <em>Legal basis:</em> performance of a contract
(Art. 6(1)(b) GDPR).
</li>
<li>
<strong>
Provision of the Service via Telegram Bot (optional):
</strong>{" "}
to provide the features of the Service (such as registering events or consulting your pets) via the Telegram bot,
if you decide to connect your account. <em>Legal basis:</em>{" "}
performance of a contract (Art. 6(1)(b) GDPR).
</li>
<li>
<strong>Payments and Subscriptions:</strong> to manage payments,
subscriptions, invoices, and charges via Stripe, including the collection
of necessary tax information. <em>Legal basis:</em> performance of a
contract and legal obligations (Art. 6(1)(b) and 6(1)(c) GDPR).
</li>
<li>
<strong>Referral Program Management:</strong> to manage the
referral program, associate your account with the user who invited you
and generate (via Stripe) and communicate to you (via email)
promotional codes as rewards. <em>Legal Basis:</em> {" "}
performance of a contract (Art. 6(1)(b) GDPR) and legitimate interest
(Art. 6(1)(f) GDPR).
</li>
<li>
<strong>Security and Fraud Prevention:</strong> to protect the
Service, monitor access history, detect unauthorized access,
and prevent abuse. <em>Legal Basis:</em> legitimate
interests of the Company (Art. 6(1)(f) GDPR).
</li>
<li>
<strong>Email Notifications:</strong> for transactional emails such as password resets,
power notifications, and service updates
via Amazon SES. <em>Legal basis:</em> performance of a
contract (Art. 6(1)(b) GDPR).
</li>
<li>
<strong>Marketing and Promotions:</strong> to send newsletters or
promotional communications, if you have consented. {" "}
<em>Legal basis:</em> consent (Art. 6(1)(a) GDPR).
</li>
<li>
<strong>Legal Compliance:</strong> retention of tax, accounting, and contractual records. <em>Legal basis:</em> legal
obligation (Art. 6(1)(c) GDPR).
</li>
</ul>
      <h3 className="text-xl font-semibold mb-2">Sharing of Your Personal Data</h3>
      <p className="mb-2">We may share Your personal information in the following situations:</p>

      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>With Service Providers: We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You.</li>
        <li>For business transfers: We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.</li>
        <li>With Affiliates: We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.</li>
        <li>With business partners: We may share Your information with Our business partners to offer You certain products, services or promotions.</li>
        <li>With other users: when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.</li>
        <li>With Your consent: We may disclose Your personal information for any other purpose with Your consent.</li>
      </ul>
<h3 className="text-xl font-semibold mb-2">
External Data Processors
</h3>
<p className="mb-2">
We share your Personal Data with the following third-party service providers
, who act as Data Processors:
</p>
<ul className="list-disc pl-6 space-y-2 mb-6">
<li>
<strong>Stripe Payments Europe Ltd.</strong> – payment processing, subscription management, and promotional code generation
for the referral program.
</li>
<li>
<strong>Amazon Web Services EMEA SARL</strong> – email services
via Amazon SES.
</li>
<li>
<strong>Hostinger International Ltd.</strong> – hosting services
(VPS located in Germany).
</li>
<li>
<strong>Google Ireland Ltd.</strong> – authentication via Google
OAuth.
</li>
<li>
<strong>Telegram FZ-LLC</strong> (or relevant legal entity) – for
sending notifications and managing service features (e.g.,
food reminders) via the Telegram bot,
exclusively with prior user connection.
</li>
</ul>
      <h3 className="text-xl font-semibold mb-2">International Data Transfers</h3>
      <p className="mb-6">
        Some of our service providers may transfer Your data outside the European Economic Area (EEA). All transfers are conducted under Standard Contractual Clauses (SCC) approved by the European Commission and using additional safeguards such as data encryption.
      </p>

      <h2 className="text-2xl font-semibold mb-3">Retention of Your Personal Data</h2>
      <p className="mb-2">
        The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our legal agreements and policies.
      </p>
      <p className="mb-6">
        The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.
      </p>

      <h2 className="text-2xl font-semibold mb-3">Transfer of Your Personal Data</h2>
      <p className="mb-6">
        Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.
      </p>

      <h2 className="text-2xl font-semibold mb-3">Delete Your Personal Data</h2>
      <p className="mb-6">
        You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You. Our Service may give You the ability to delete certain information about You from within the Service. You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us. Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.
      </p>
      <h3 className="text-xl font-semibold mb-2">Your GDPR Rights</h3>
      <p className="mb-2">
        Under the GDPR, You have the following rights regarding Your Personal Data:
      </p>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>Right to access your data (Art. 15 GDPR).</li>
        <li>Right to correct or update your data (Art. 16 GDPR).</li>
        <li>Right to delete your data (Art. 17 GDPR).</li>
        <li>Right to restrict processing (Art. 18 GDPR).</li>
        <li>Right to data portability (Art. 20 GDPR).</li>
        <li>Right to object to processing, including marketing (Art. 21 GDPR).</li>
        <li>Right to withdraw consent at any time where processing is based on consent.</li>
        <li>Right to lodge a complaint with the <a href="https://www.garanteprivacy.it" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">Italian Data Protection Authority (Garante Privacy)</a>.</li>
      </ul>
      <p className="mb-6">
        To exercise any of these rights, please contact us at <strong>support@snakebee.it</strong>.
      </p>

      <h2 className="text-2xl font-semibold mb-3">Disclosure of Your Personal Data</h2>
      <h3 className="text-xl font-semibold mb-2">Business Transactions</h3>
      <p className="mb-2">
        If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.
      </p>

      <h3 className="text-xl font-semibold mb-2">Law enforcement</h3>
      <p className="mb-2">
        Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).
      </p>

      <h3 className="text-xl font-semibold mb-2">Other legal requirements</h3>
      <p className="mb-6">
        The Company may disclose Your Personal Data in the good faith belief that such action is necessary to: Comply with a legal obligation, Protect and defend the rights or property of the Company, Prevent or investigate possible wrongdoing in connection with the Service, Protect the personal safety of Users of the Service or the public, Protect against legal liability.
      </p>

      <h2 className="text-2xl font-semibold mb-3">Security of Your Personal Data</h2>
      <p className="mb-6">
        The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.
      </p>
      <p className="mb-6">
        We implement appropriate technical and organizational measures to protect Your Personal Data, including:
      </p>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>Encryption of data in transit using TLS.</li>
        <li>Hashed and salted passwords for all accounts.</li>
        <li>Multi-factor authentication (MFA) for administrative access.</li>
        <li>Encrypted backups and secure storage of sensitive data.</li>
        <li>Segregation of development and production environments.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-3">Children's Privacy</h2>
      <p className="mb-6">
        Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.
      </p>

      <h2 className="text-2xl font-semibold mb-3">Links to Other Websites</h2>
      <p className="mb-6">
        Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit. We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
      </p>

      <h2 className="text-2xl font-semibold mb-3">Changes to this Privacy Policy</h2>
      <p className="mb-6">
        We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page. We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
      </p>
      <p className="mb-2">
        We retain Your Personal Data only as long as necessary for the purposes described in this Privacy Policy:
      </p>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>Account data and profile: until account deletion or user request.</li>
        <li>Login history and security logs: last 20 visits.</li>
        <li>Payment and subscription records: 10 years (legal obligation).</li>
        <li>Email marketing consent: until revoked by the user.</li>
        <li>User-generated content (reptiles, forum/blog posts, images): until account deletion.</li>
        <li>Refresh tokens: for the duration of account activity.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-3">Contact Us</h2>
      <p className="mb-6">If you have any questions about this Privacy Policy, You can contact us:</p>
      <p className="mb-6">By email: support@snakebee.it || PEC simonevaira@postecertifica.it</p>

    </div>

  );
};

export default PrivacyPolicyEN;
